export enum EModule {
  GLOBAL = "GBL",
  HELPDESK = "HD",
  TOWERMANAGEMENT = "TWM",
  FINANCIAL = "FIN",
  SUPPLIES = "SPL",
}

export enum ESchema {
  APIKEYS = "apiKeys",
  TASKS = "TASKS",
  PROFILES = "profiles",
  FILTERS = "filters",
  CUSTOMERS = "customers",
  SITES = "sites",
  STATUSES = "statuses",
  STAGES = 'stages',
  TOWERS = "towers",
  TEAMS = "teams",
  MAINTENANCES = "maintenances",
  PLANNINGSMAINTENANCES = "planningsMaintenances",
  SERVICES = "services",
  JOBS = "jobs",
  SCOPES = "scopes",
  ACTIVITIES = "activities",
  ROUTINGS = "routings",
  ROUTES = "routes",
  DISTANCES = "distances",
  ROUTINGMAINTENANCES = "routingMaintenances",
  OUTSOURCEDES = "outsourcedes",
  USERS = "users",
  AUTOINCS = "autoIncs",
  AUDITS = "audits",
  LOGS = "logs",
  AUTHLOGS = "authlogs",
  ACTIVITYINTERACTIONS = "activityInteractions",
  FILES = "files",
  ACTIVITYFILES = "activityFiles",
  PATHOLOGIES = "pathologies",
  FORMS = "forms",
  OCCURRENCES = "occurrences",
  ITEMS = "items",
  ACTIVITYITEMS = "activityItems",
  MEASUREMENTS = "measurements",
  CONTRACTS = "contracts",
  CONTRACTVALUES = "contractValues",
  CONTRACTPERIODICITIES = "contractPeriodicities",
  PRICINGPLANS = "pricingPlans",
  PRICINGVALUES = "pricingValues",
  EHSDOCUMENTTYPES = "ehsDocumentTypes",
  EHSDOCUMENTS = "ehsDocuments",
  AIPATHOLOGYSCHEDULES = 'aiPathologySchedules',
  AIPATHOLOGYANALYSES = 'aiPathologyAnalyses',
  ACCESS_REQUESTS = 'accessRequests',
}

export enum EEntity {
  GBL_SSOPROVIDERS = "gbl_SSOProviders",
  GBL_MODULES = "gbl_modules",
  GBL_USERS = "gbl_users",
  GBL_USERPREFERENCES = "gbl_userPreferences",
  GBL_PROFILES = "gbl_profiles",
  GBL_GROUPS = "gbl_groups",
  GBL_FILES = "gbl_files",
  GBL_JOBS = "gbl_jobs",
  GBL_JOBLOGS = "gbl_jobLogs",
  GBL_FILTERS = "gbl_filters",
  GBL_PERMISSIONS = "gbl_permissions",
  GBL_AUDITS = "gbl_audits",
  GBL_LOGS = "gbl_logs",
  GBL_AUTHLOGS = "gbl_authLogs",
  GBL_CUSTOMFIELDS = "gbl_customFields",
  GBL_CUSTOMFIELDVALUES = "gbl_customFieldValues",
  GBL_NOTIFICATIONS = "gbl_notifications",
  GBL_APIKEYS = 'gbl_apiKeys',
  GBL_FIELD_CATALOG_PERMISSIONS = "gbl_fieldCatalogPermissions",
  GBL_AIPATHOLOGYSCHEDULES = 'gbl_aiPathologySchedules',
  GBL_AIPATHOLOGYANALYSES = 'gbl_aiPathologyAnalyses',

  // tower manager
  TWM_SITES = "twm_sites",
  TWM_CUSTOMERS = "twm_customers",
  TWM_CUSTOMER_REQUESTERS = "twm_customerRequesters",
  TWM_TOWERS = "twm_towers",
  TWM_STATUSES = "twm_statuses",
  TWM_STAGES = 'twm_stages',
  TWM_SERVICES = "twm_services",
  TWM_SCOPES = "twm_scopes",
  TWM_OUTSOURCEDES = "twm_outsourcedes",
  TWM_TEAMS = "twm_teams",
  TWM_TEAMUSERS = "twm_teamUsers",
  TWM_PLANNINGSMAINTENANCES = "twm_planningsMaintenances",
  TWM_MAINTENANCES = "twm_maintenances",
  TWM_ROUTINGS = "twm_routings",
  TWM_ROUTINGMAINTENANCES = "twm_routingMaintenances",
  TWM_ROUTES = "twm_routes",
  TWM_REGIONS = "twm_regions",
  TWM_REASONS = "twm_reasons",
  TWM_PRICINGPLANS = "twm_pricingPlans",
  TWM_PRICINGVALUES = "twm_pricingValues",
  TWM_ITEMS = "twm_items",
  TWM_CONTRACTS = "twm_contracts",
  TWM_CONTRACTVALUES = "twm_contractValues",
  TWM_MEASUREMENTS = "twm_measurements",
  TWM_MEASUREMENTENTRIES = "twm_measurementEntries",
  TWM_MEASUREMENTINCONSISTENCIES = "twm_measurementInconsistencies",
  TWM_OCCURRENCES = "twm_occurrences",
  TWM_OCCURRENCEACTIVITYFILES = "twm_occurrenceActivityFiles",
  TWM_DISTANCES = "twm_distances",
  TWM_ACTIVITIES = "twm_activities",
  TWM_ACTIVITYFILES = "twm_activityFiles",
  TWM_ACTIVITYITEMS = "twm_activityItems",
  TWM_ACTIVITYINTERACTIONS = "twm_activityInteractions",
  TWM_PATHOLOGIES = "twm_pathologies",
  TWM_ACTIVITYENTRIES = "twm_activityEntries",
  TWM_APPROVALFLOWS = "twm_approvalFlows",
  TWM_APPROVALFLOWFIELDS = "twm_approvalFlowFields",
  TWM_APPROVALFLOWSTEPS = "twm_approvalFlowSteps",
  TWM_APPROVALFLOWSTEPLINKS = "twm_approvalFlowStepLinks",
  TWM_APPROVALFLOWEXECUTIONS = "twm_approvalFlowExecutions",
  TWM_APPROVALFLOWEXECUTIONINTERACTIONS = "twm_approvalFlowExecutionInteractions",
  TWM_APPROVALFLOWEXECUTIONFILES = "twm_approvalFlowExecutionFiles",
  TWM_APPROVALFLOWEXECUTIONSTEPS = "twm_approvalFlowExecutionSteps",
  TWM_APPROVALFLOWEXECUTIONSTEPLINKS = "twm_approvalFlowExecutionStepLinks",
  TWM_APPROVALFLOWEXECUTIONFIELDS = "twm_approvalFlowExecutionFields",
  TWM_LOCATIONSCURRENTS = "twm_locationsCurrents",
  TWM_LOCATIONSHISTORY = "twm_locationsHistory",
  TWM_FORMS = "twm_forms",
  TWM_FIELDS = "twm_fields",
  TWM_FIELDOPTIONS = "twm_fieldOptions",
  TWM_FORMFIELDS = "twm_formfields",
  TWM_FORMRESPONSES = "twm_formResponses",
  TWM_FIELDRESPONSES = "twm_fieldResponses",
  TWM_FORMASSIGNMENTCONDITIONS = "twm_formAssignmentConditions",
  TWM_FORMRULES = "twm_formRules",
  TWM_ACCESSTYPES = "twm_accessTypes",
  TWM_SLAS = "twm_slas",
  TWM_SLARULES = "twm_slaRules",
  TWM_UNITOFMEASURES = 'twm_unitOfMeasures',
  TWM_ORIGINS = "twm_origins",
  TWM_EQUIPMENTS = "twm_equipments",
  TWM_CATEGORYEQUIPMENT = 'twm_categoryEquipment',
  TWM_EQUIPMENTMODELS = 'twm_equipmentModels',
  TWM_ACCESS_REQUESTS = "twm_access_requests",

  // EHS
  TWM_EHS_DOCUMENT_TYPES = "twm_ehsDocumentTypes",
  TWM_EHS_DOCUMENTS = "twm_ehsDocuments",
  TWM_EHS_DOCUMENT_STATUS_HISTORY = "twm_ehsDocumentStatusHistory",
  TWM_EHS = "twm_ehs",
  TWM_EHS_EXECUTION = "twm_ehsExecution",
  TWM_EHS_MONITORING = "twm_ehsMonitoring",
  TWM_EHS_MANAGEMENT = "twm_ehsManagement",

  // help desk
  HD_FORMS = 'helpdesk_forms',
  HD_CUSTOMFIELDS = 'helpdesk_customFields',
  HD_FORMCUSTOMFIELDS = 'helpdesk_formCustomFields',
  HD_TICKETS = 'helpdesk_tickets',
  HD_TICKETCUSTOMFIELDS = 'helpdesk_ticketCustomFields',

  // financial
  FIN_HOME = "fin_home",
  FIN_ENTRIES = "fin_entries",
  FIN_ENTRIES_HISTORY = "fin_entriesHistory",
  FIN_CUSTOMERSSUPPLIERS = "fin_customersSuppliers",
  FIN_INVOICES = "fin_invoices",
  FIN_INVOICEENTRIES = "fin_invoiceEntries",
  FIN_ENTRYLOWS = "fin_entryLows",
  FIN_CASHACCOUNTS = "fin_cashAccounts",
  FIN_INVOICECONCILIATIONS = "fin_invoiceConciliations",
  FIN_ENTRYLINKS = "fin_entryLinks",
  FIN_CATEGORIES = "fin_categories",
  FIN_PAYMENTTERMS = "fin_paymentTerms",
  FIN_ENTRYPAYMENTTERMS = "fin_entryPaymentTerms",
  FIN_COSTCENTERS = "fin_costCenters",
  FIN_ENTRYCOSTCENTERS = "fin_entryCostCenters",
  FIN_COSTCENTERRULES = "fin_costCenterRules",
  FIN_COSTCENTERGOALS = "fin_costCenterGoals",

  // supplies
  SPL_HOME = "spl_home",
  SPL_PRODUCT = "spl_products",
  SPL_PRODUCT_SKUS = "spl_product_SKUs",
  SPL_PRODUCT_TYPES = "spl_product_types",
  SPL_PRODUCT_BRANDS = "spl_product_brands",
  SPL_PRODUCT_GROUPS = "spl_product_groups",
  SPL_PRODUCT_ATTRIBUTES = "spl_product_attributes",
  SPL_PRODUCT_CATEGORIES = "spl_product_categories",
  SPL_PRODUCT_ATTRIBUTES_TYPES = "spl_attributes_types",
  SPL_PRODUCT_SKU_ATTRIBUTES = "spl_product_SKU_attributes",
  SPL_PRODUCT_ATTRIBUTES_TYPE_GROUPS = "spl_product_attributes_type_groups",
  SPL_PRODUCT_GROUPS_TYPES = "spl_product_groups_types",

  SPL_WAREHOUSE_CONTACTS = "spl_warehouse_contacts",
  SPL_WAREHOUSE_ADDRESSES = "spl_warehouse_addresses",
  SPL_WAREHOUSES = "spl_warehouses",
  SPL_WAREHOUSE_ITEMS = "spl_warehouse_items",
  SPL_WAREHOUSE_STOCK_MOVEMENTS = "spl_warehouse_stock_movements",
  SPL_WAREHOUSE_ITEM_STATUS = "spl_warehouse_item_status",
}
